import React, { useState, useEffect } from 'react'
import { PrimaryButton } from '../../../ui'
import style from './cookie-style.m.less'

const CookieModal: React.FC = () => {
    const [isVisible, setIsVisible] = useState<boolean>(false)

    useEffect(() => {
        // Проверяем наличие флага в localStorage
        const cookieAccepted = localStorage.getItem('CookieAccepted')
        if (!cookieAccepted) {
            setIsVisible(true)
        }
    }, [])

    const handleAccept = () => {
        localStorage.setItem('CookieAccepted', 'true') // Сохраняем флаг
        setIsVisible(false) // Закрываем модальное окно
    }

    return (
        <>
            {isVisible && (
                <div className={style.cookieCard}>
                    <div className={style.cookieBody}>
                        <p>
                            Мы используем файлы cookie. Они помогают сделать наш сайт (систему
                            реестра атрибутов генерации) удобнее. Продолжая использовать сайт
                            (систему реестра атрибутов генерации), Вы соглашаетесь с{' '}
                            <a
                                className={style.agreeLink}
                                href="/documents/cookiePolicy.pdf"
                                target="_blank"
                            >
                                обработкой файлов cookie
                            </a>
                            , в том числе с использованием сервиса веб-аналитики Яндекс.Метрика, на
                            указанных в{' '}
                            <a
                                className={style.agreeLink}
                                href="/documents/privacyPolicy.pdf"
                                target="_blank"
                            >
                                Политике о конфиденциальности и обработке персональных данных
                            </a>{' '}
                            условиях. Вы можете отключить файлы cookies в настройках своего
                            браузера.
                        </p>
                        <PrimaryButton
                            key="accept"
                            value={'Принять'}
                            onClick={handleAccept}
                            className={style.cookieBtn}
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default CookieModal
